<script setup lang="ts">
    import { __ } from '../../stores/expressions';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import UsersTable from './UsersTable.vue';
    import { useUsersTableData } from '@/js/stores/users-table';
    import { SearchIcon } from '@lucide/vue';

    const table = useUsersTableData();
</script>

<template>
    <div class="flex gap-10 items-center pb-12">
        <TextInput
            v-model="table.search"
            :width="TextInputWidth.Large"
            :placeholder="__('users-list-search-placeholder')"
        >
            <template #end-adornment><SearchIcon /></template>
        </TextInput>
    </div>
    <UsersTable />
</template>
